import type { WellStructureChangeStatusMessage } from '@go-widgets/well-logs-widget';

import { WELL_STATUS_SOCKET_URL } from 'src/api/consts';
import type { IServicesCollection } from 'src/packages/di';

import type { ISockClientService } from '../sock-client-service/SockClientService';
import { SockClientService } from '../sock-client-service/SockClientService';

export type TWellStatus = 'COMPLETED' | 'ACTIVE_GREEN' | 'ACTIVE_YELLOW' | 'ACTIVE_RED';

export type WellStatusMessage = {
  wellId: number;
  status: TWellStatus;
};

type BroadcastListMsg = {
  broadcastId: number;
};

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    wellStatusService: ISockClientService<WellStatusMessage & BroadcastListMsg & WellStructureChangeStatusMessage>;
  }
}

export async function addWellStatusService(di: IServicesCollection): Promise<void> {
  const wellStatusService = new SockClientService<
    WellStatusMessage & BroadcastListMsg & WellStructureChangeStatusMessage
  >(WELL_STATUS_SOCKET_URL);
  // TODO: вернуть await
  wellStatusService.init();

  di.addSingleton('wellStatusService', wellStatusService);
}
